export const WEIGHT_MULTIPLIER_MG = 0
export const WEIGHT_MULTIPLIER_G = 1
export const WEIGHT_MULTIPLIER_KG = 2

export const PRODUCT_STATUS_EXCLUDED = -1
export const PRODUCT_STATUS_DISABLED = 0
export const PRODUCT_STATUS_ENABLED = 1

export const PRODUCT_STATUS_LABELS = [
  {
    label: 'Активен',
    value: PRODUCT_STATUS_ENABLED
  },
  {
    label: 'Отключён до синхронизации',
    value: PRODUCT_STATUS_DISABLED
  },
  {
    label: 'Недоступен',
    value: PRODUCT_STATUS_EXCLUDED
  }
]

export const ORDER_META_STATUS_REFUNDED_BEFORE_DELIVERY = -2
export const ORDER_META_STATUS_REFUNDED = -1
export const ORDER_META_STATUS_WAITING_ASSEMBLER = 0
export const ORDER_META_STATUS_ASSEMBLING = 1
export const ORDER_META_STATUS_NEED_CONTACT = 2
export const ORDER_META_STATUS_REPLACED = 3
export const ORDER_META_STATUS_REMOVED = 4
export const ORDER_META_STATUS_ASSEMBLED = 5
export const ORDER_META_STATUS_ADDED_BY_OPERATOR = 6

/*
  Api file field name for uploading stuff
*/

export const UPLOAD_NAME_PRODUCT_PREVIEW = 'product-preview'
